<img
  [src]="categoryImageUrl"
  [alt]="category().name"
  [attr.loading]="loading"
  [attr.fetchpriority]="loading === 'eager' ? 'high' : null"
  itemprop="image"
/>
